import { getResponseJson } from '../../../services/getresponsejson.js';

function createClientReviewLandingPageService(serviceRoutes) {
  const initializePage = () => {
    return fetch(serviceRoutes.initializePage, {
      credentials: 'include'
    })
    .then(getResponseJson);
  };

  const beginWork = () => {
    return fetch(serviceRoutes.beginWork, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ foo: 'bar' })
    })
    .then(getResponseJson);
  };

  const acceptAllReviews = () => {
    return fetch(serviceRoutes.acceptAllReviews, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({})
    })
    .then(getResponseJson);
  };

  const searchReviews = searchConfiguration => {
    return fetch(serviceRoutes.searchReviews, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(searchConfiguration)
    })
    .then(getResponseJson);
  };

  return {
    initializePage,
    beginWork,
    acceptAllReviews,
    searchReviews,
    serviceRoutes
  };
}

export { createClientReviewLandingPageService };
